
<template>
    <InvoicesContainer
        :project="selectedProject"
        :year="selectedYear"
        :yearOptions="yearOptions"
    />
</template>

<script>
import store from '@/store'
import InvoicesContainer from '@/modules/Invoices'
import InvoicesStore from '@/modules/Invoices/_store'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectYear from '@/composables/useSelectYear'
import { computed, getCurrentInstance } from '@vue/composition-api'
const STORE_KEY = '$_invoice'

export default {
    components: {
        InvoicesContainer
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectedProject,
            selectedGroup,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            yearModel,
            yearOptions,
            selectedYear,
            setInitialYearSelect
        } = useSelectYear(STORE_KEY)

        // 그룹만 선택된 진입(일괄 모드)에서는 계정이 없다. 이때 기본 계정을 강제로 넣으면
        // 사용자가 고른 그룹 선택이 덮여 일괄 화면이 뜨지 않는다.
        const isGroupOnly = computed(() => !!selectedGroup.value?.groupIdx && !selectedProject.value?.usageAccountId)

        if (!selectedProject.value && !isGroupOnly.value) {
            setInitialAccountSelect()
        }

        const usageAccountId = selectedProject.value?.usageAccountId
        if (usageAccountId) {
            store.dispatch(`${STORE_KEY}/getInvoiceMonths`, { usageAccountId }).then(({ data }) => {
                if (data) {
                    const year = data.length && data[0].substring(0, 4)
                    setInitialYearSelect()
                    store.dispatch(`${STORE_KEY}/getInvoiceAnnualSummary`, { usageAccountId, year })
                }
            })
        }
        return {
            selectedProject,
            yearModel,
            selectedYear,
            yearOptions
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, InvoicesStore)
        }
        next()
    }
}
</script>

<style>

</style>
